// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mzpe","col":"styles_col__muu2f"};